import React, { useEffect, Fragment, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { verifyCookie } from '../../lib/verify-cookies';
import jwtDecode from 'jwt-decode';
import { userActions } from '../../store/user-slice';
import { clientActions } from '../../store/client-slice';
import useHttp from '../../hooks/use-http';
import { validateOauthToken, getMembershipStatus } from '../../lib/api';
import { activeMembership } from '../../lib/verifyMembership';

const Authenticate = () => {
  const dispatch = useDispatch();
  const history = useNavigate();
  const params = new URLSearchParams( window.location.search );
  const code = params.get( 'code' );
  const authCookie = verifyCookie( 'auth_code' );
  const [error, setError] = useState( false );
  const [loading, setLoading] = useState();

  const { sendRequest, status, data: oauthResponse } = useHttp( validateOauthToken );

  useEffect( () => {
    sendRequest( code );
  }, [code, sendRequest] );


  useEffect( () => {
    const getToken = async() => await jwtDecode( authCookie );

    if ( !code ){
      getToken().then( ( jwToken ) => {
        window.location = `https://${jwToken.neonClientName}.app.neoncrm.com/np/oauth/auth?response_type=code&client_id=${encodeURIComponent( jwToken.neonOauthId )}&redirect_uri=${process.env.REACT_APP_URL_DOMAIN}/authenticate`;
      } ).catch( ex => {
        console.log( ex, authCookie );
      } );
    }

    const updateOauthState = async ( data ) => {
      dispatch( userActions.setIsLoggedIn( data ) );
      const jwToken = await getToken();
      const storeData = {
        apiKey: jwToken.apiKey,
        neonClientName: jwToken.neonClientName,
        abbreviation: jwToken.abbreviation,
        neonAdminToken: jwToken.neonAdminToken,
        neonOauthId: jwToken.neonOauthId,
        neonOauthSecret: jwToken.neonOauthSecret
      };

      dispatch (
        clientActions.setNeonApiKey( storeData )
      );
    };

    const verifyAuth = async ( accountId ) => {
      const jwToken = await getToken();
      const params = {
        apiKey: jwToken.apiKey,
        client: jwToken.neonClientName,
        accountId: accountId
      };
      const response = await getMembershipStatus( params );
      return response;
    };

    if ( status === 'completed' && oauthResponse && oauthResponse.access_token ){
      setError( false );
      setLoading( true );

      verifyAuth( oauthResponse.access_token ).then( ( isAuthorized ) => {
        activeMembership( isAuthorized );
        if ( isAuthorized && activeMembership( isAuthorized ) ){
          document.cookie = `neon_access_token=${oauthResponse.access_token};max-age=604800;domain${process.env.REACT_APP_DOMAIN}`;
          updateOauthState( oauthResponse.access_token );

          history( '/', { replace: true } );
        }
        else {
          setError( true );
          setLoading( false );
        }


      } );
    }

  }, [history, oauthResponse, status, dispatch, authCookie, code] );





  return (
    <Fragment>
      {error && <p>Unauthorized User</p>}
      {loading && <p>Loading...</p>}
    </Fragment>
  );
};





export default Authenticate;